import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Button, FullBar, Icons } from "cakemail-ui-components/lib/react";
import { Translate } from "react-redux-i18n";
import PropTypes from "prop-types";

let key = new Date().getTime();
export const BrandChannelConfiguration = (props) => {
	return (
		<div className="brandModalTabContent" key={key}>
			<FullBar
				className="tabContentTitleRow"
				left={
					<p className="h7">
						<b>
							<Translate
								value={`app-brand-modal-tabs-${props.channelStringsKey}`}
							/>
						</b>
					</p>
				}
				right={
					props.preview ? (
						<Button
							shapeStyle="stroke"
							text={
								<>
									<Icons name="glyph-show" />{" "}
									<Translate value="app-general-preview" />
								</>
							}
							onClick={props.preview}
						/>
					) : null
				}
			/>
			<div className="brandElementsContainer">{props.children}</div>
		</div>
	);
};

BrandChannelConfiguration.propTypes = {
	preview: PropTypes.func,
	channelStringsKey: PropTypes.string,
};

BrandChannelConfiguration.defaultProps = {};

export default withRouter(
	connect(
		(state) => {
			return {};
		},
		(dispatch) => bindActionCreators({}, dispatch)
	)(BrandChannelConfiguration)
);
